// useInstagramAccounts — hook pour lister les comptes Instagram connectés du tenant.
// Pas encore de TanStack Query côté frontend (pas setup) → on reste sur useState/useEffect.
// Le jour où on adoptera React Query, ce hook sera simple à remplacer.

import { useCallback, useEffect, useState } from 'react';
import { api, ApiError } from '../lib/api';

export interface InstagramAccount {
  id: string;
  igUserId: string;
  handle: string;
  status: 'ACTIVE' | 'EXPIRED' | 'DISCONNECTED';
  tokenExpiresAt: string;
  connectedFacebookPageId: string | null;
  createdAt: string;
}

interface UseInstagramAccountsState {
  accounts: InstagramAccount[];
  loading: boolean;
  error: string | null;
  reload: () => Promise<void>;
  revoke: (id: string) => Promise<void>;
}

export function useInstagramAccounts(): UseInstagramAccountsState {
  const [accounts, setAccounts] = useState<InstagramAccount[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await api.get<{ accounts: InstagramAccount[] }>('/api/instagram/accounts');
      setAccounts(data.accounts);
    } catch (e) {
      const msg = e instanceof ApiError ? e.message : 'Erreur de chargement';
      setError(msg);
    } finally {
      setLoading(false);
    }
  }, []);

  const revoke = useCallback(
    async (id: string) => {
      await api.delete(`/api/instagram/accounts/${id}`);
      await load();
    },
    [load],
  );

  useEffect(() => {
    void load();
  }, [load]);

  return { accounts, loading, error, reload: load, revoke };
}
